export default __webpack_public_path__ + "static/media/Cootie (2020).d9bda823.jpg";